import { TypeVoie } from './TypeVoie';
export class TypeAdresse {

	public lieuDit: string;

	public voie: TypeVoie;

	public voie_e: TypeVoie;

	public ville: string;

	public ville_e: string;

	public cx: number;

	public cp: string;

	public cp_e: string;

	public bp: number;

	public pays: string;

	constructor() {
		this.lieuDit = '';
		this.voie = new TypeVoie();
		this.voie_e = new TypeVoie();
		this.ville = '';
		this.ville_e = '';
		this.cx = 0;
		this.cp = '';
		this.cp_e = '';
		this.bp = 0;
		this.pays = null;

	}
}
